export enum UploadState {
    none = 0,
    pending = 1,
    uploading = 2,
    uploaded = 3,
    canceled = 4
}